var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppSubstance3DPainter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#1E3101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6694 14.4297C26.7002 14.4297 30.6592 17.7229 30.6592 23.2363C30.6592 29.6748 25.294 32.2649 20.2617 32.2649H16.8574V39.2214H9.97461V14.4297H19.6694ZM16.8574 20.3132V26.3816H19.8916C22.0005 26.3816 23.4805 25.5305 23.4805 23.3843C23.4805 21.4231 22.2227 20.3132 20.0391 20.3132L16.8574 20.3132Z",
    fill: "#99E83F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1397 20.0911H44.6924V25.2344H41.1397V31.821C41.1397 33.5969 41.8799 34.2632 43.1377 34.2632C43.5449 34.2632 44.1367 34.1892 44.6924 34.0041L44.729 39.1103C43.9151 39.4065 43.0269 39.5915 41.3618 39.5915C37.1436 39.5915 34.6641 37.5933 34.6641 32.8569V25.2344H31.8892V20.0911H34.6641V15.2439H41.1397L41.1397 20.0911Z",
    fill: "#99E83F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppSubstance3DPainter);
export default __webpack_public_path__ + "static/media/B_app_Substance3DPainter.12af63a4d1e23d2fe958486e2287f38a.svg";
export { ForwardRef as ReactComponent };